export const ROUTES = {
  aiCodingOutputs: {
    parentPath: "/clinical-coding",
    slug: "ai-coding-outputs",
    route: "/clinical-coding/ai-coding-outputs",
  },
  humanCodingReview: {
    parentPath: "clinical-coding",
    slug: "human-coding-review",
    route: "/clinical-coding/human-coding-review",
  },
  unwrittenEncounterReview: {
    parentPath: "clinical-coding",
    slug: "unwritten-encounters",
    route: "/clinical-coding/unwritten-encounters",
  },
};
